import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // language resources
    resources: {
      en: {
        translation: {
         home_welcome: "Welcome ADMIN",
         login_text: "Login",
         login_title: "Login to get started",
         logout: "Logout",
   
         copywright_text: "© 2023 GicMed. All rights reserved",
       
         account_text: "Don't have an account?",
         welcome_back_text: "Welcome Back",
         welcome_back_sub: "Nice to see you",
         email_required_error: "Email field is required",
         email_valid_error: "Enter a valid email",
         password_required_error: "Password Required",
         login_success_text: "Logged In Succesfuly",
         login_error_text: "Email or password is wrong",
         username_required_error: "Username is required",
 
         username_label: "Email",
         password_label: "Password",
         c_password_label: "Confirm Password",
         hello:"Hello",
        
         lab: { 
            home_title: 'Patient Reports',
            dashboard_text: "Dashboard",
            reports_text: "Reports",
            all_reports: "All Reports",
            add_patient: "Add Patient",
            search_label: "Search for data..",
            add_modal: {
                add_text: "Add Patient",
                code: "Code",
                code_label: "Enter Code",
                patient_name: "Patient's Name",
                patient_name_label: "Enter Patient's Name",
                patient_phone: "Patient's Phone",
                patient_phone_label: "Enter Patient's Phone",
                btn_text: "ADD PATIENT",

                success: "Patient Added",
                phone_exist: "PHONE HAS ALREADY BEEN ADDED",
                code_required: "Code is required",
                name_required: "Name is required",
                phone_digit: "Must be at least  9 digits",
                digit_min: "Must be 9 digits",
                digit_required: "Phone is required"
            },

            upload_modal: {
                title: "Upload Report For",
                report_name: "Report Name",
                upload_report: "Upload Report",
                uploading: "Uploading Content",
                done: "Done",
                submit_report: "SUBMIT REPORT"
            },

            table_1: {
                patient_phone: "Patient Phone",
                patient_status: "Patient Status",
                date_created: "Date Created",
                action: "Action",
                upload_new: "Upload New Report"
            },
            table_2: {
                report_name: "Report Name",
                date_uploaded: "Date Uploaded",
                action: 'Action'
            },

            side_bar: 'Reports'
         },


         layout:{
             dashboard:"Dashboard",
             home:"Home"
         },
         student_layout:{
            dashboard:"Dashboard",
            course_content:"Course Content",
            assignment:"Assignments",
            assessment:"Assessments",
            assessment_submission:"Assessment Submissions",
        },
         landing:{
            cards:{
                stat_card_classroom:"Total Classrooms",
                stat_card_course_content:"Total Course Content",
                stat_card_application:"Total Applications",
                stat_card_assessments:"Total Assessments",
            },
            data_table:{
                layout_title:"Dashboard",
                title:"Student Application",
                student_name:"Student",
                class_name:"Class Name",
                status:"Status",
                submitted_date:"Submitted Date",
            },
        },

        },
      },

      fr: {
        translation: {
          home_welcome: "Bienvenue ADMIN",
          login_text: "Connexion",
          login_title: "Connectez-vous pour commencer",
          logout: "Déconnexion",
         
          copywright_text: "© 2023 GicMed. Tous droits réservés",
          account_text: "Vous n'avez pas de compte ?",
          welcome_back_text: "Bienvenue de retour",
          welcome_back_sub: "Ravi de vous revoir",
          email_required_error: "Le champ Email est requis",
          email_valid_error: "Veuillez entrer une adresse email valide",
          password_required_error: "Mot de passe requis",
          login_success_text: "Connecté avec succès",
          login_error_text: "Email ou mot de passe incorrect",
          username_required_error: "Le nom d'utilisateur est requis",
          username_label: "Email",
          password_label: "Mot de passe",
          c_password_label: "Confirmer le mot de passe",
          hello: "Bonjour",
          lab: {
            home_title: "Rapports des Patients",
            dashboard_text: "Tableau de bord",
            reports_text: "Rapports",
            all_reports: "Tous les rapports",
            add_patient: "Ajouter un patient",
            search_label: "Rechercher des données...",
            add_modal: {
              add_text: "Ajouter un patient",
              code: "Code",
              code_label: "Saisissez le code",
              patient_name: "Nom du patient",
              patient_name_label: "Saisissez le nom du patient",
              patient_phone: "Numéro de téléphone du patient",
              patient_phone_label: "Saisissez le numéro de téléphone du patient",
              btn_text: "AJOUTER UN PATIENT",

              success: "Patient ajouté",
                phone_exist: "LE NUMÉRO DE TÉLÉPHONE A DÉJÀ ÉTÉ AJOUTÉ",
                code_required: "Le code est requis",
                name_required: "Le nom est requis",
                phone_digit: "Doit comporter au moins 9 chiffres",
                digit_min: "Doit comporter 9 chiffres",
                digit_required: "Le numéro de téléphone est requis"
            },
            upload_modal: {
                title: "Télécharger un rapport pour",
                report_name: "Nom du rapport",
                upload_report: "Télécharger le rapport",
                uploading: "Téléchargement en cours",
                done: "Terminé",
                submit_report: "SOUMETTRE LE RAPPORT"
            },
            table_1: {
              patient_phone: "Téléphone du patient",
              patient_status: "Statut du patient",
              date_created: "Date de création",
              action: "Action",
              upload_new: "Télécharger un nouveau rapport"
            },
            table_2: {
              report_name: "Nom du rapport",
              date_uploaded: "Date du téléchargement",
              action: "Action"
            },
            side_bar: "Rapports"
          },
          layout: {
            dashboard: "Tableau de bord",
            home: "Accueil"
          },
          student_layout: {
            dashboard: "Tableau de bord",
            course_content: "Contenu du cours",
            assignment: "Devoirs",
            assessment: "Évaluations",
            assessment_submission: "Soumissions d'évaluations"
          },
          landing: {
            cards: {
              stat_card_classroom: "Total des salles de classe",
              stat_card_course_content: "Total du contenu du cours",
              stat_card_application: "Total des demandes",
              stat_card_assessments: "Total des évaluations"
            },
            data_table: {
              layout_title: "Tableau de bord",
              title: "Demande d'étudiant",
              student_name: "Étudiant",
              class_name: "Nom de la classe",
              status: "Statut",
              submitted_date: "Date de soumission"
            }
          }
        }
      }
    }
  });

export default i18n;